import * as React from "react";
import { useMergeRefs } from "@floating-ui/react";
import { useMediaQuery } from "react-responsive";
import { Button } from "../../button/button.mjs";
import { Search } from "../../form/search/search.mjs";
import { media } from "../../helpers/theme-provider/theme-provider.mjs";
import { HeaderInnerContext } from "../header/header-inner-context.mjs";
const HeaderSearch = (props) => {
  const { openSection, setOpenSection, isSearchMinimized } = React.useContext(HeaderInnerContext);
  const { detailedViewButton, onSubmit, onFocus, onShow, onClose, id = "header-search", inputRef: inputRefProp, ...rest } = props;
  const input = React.useRef(null);
  const isOpenRef = React.useRef(false);
  const isLargeScreen = useMediaQuery({ minWidth: media.width.xl.min });
  const handleSubmit = React.useCallback(
    (event) => {
      var _a;
      if (!input.current || input.current.value.length < 1) {
        event.preventDefault();
        (_a = input.current) == null ? void 0 : _a.focus();
      }
      if (onSubmit) {
        onSubmit(event);
      }
    },
    [onSubmit]
  );
  const handleFocus = React.useCallback(() => {
    setOpenSection("search");
    if (onFocus) {
      onFocus();
    }
  }, [onFocus, setOpenSection]);
  const handleBlur = React.useCallback(() => {
    if (!isSearchMinimized && isLargeScreen && !isOpenRef.current) {
      setOpenSection(null);
    }
  }, [isSearchMinimized, isLargeScreen, setOpenSection]);
  const handleShow = React.useCallback(() => {
    isOpenRef.current = true;
    if (onShow) {
      onShow();
    }
  }, [onShow]);
  const handleClose = React.useCallback(() => {
    isOpenRef.current = false;
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  const inputRef = useMergeRefs([input, inputRefProp]);
  React.useEffect(() => {
    if (openSection === "search" && input.current) {
      input.current.focus();
    }
  }, [openSection]);
  return /* @__PURE__ */ React.createElement(
    Search,
    {
      ...rest,
      inputRef,
      onSubmit: handleSubmit,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onShow: handleShow,
      onClose: handleClose,
      className: "header__search",
      id,
      hideLabel: "no-break",
      placeholderLabel: true,
      suggestionClassName: "header__search-suggestion",
      offsetY: 5,
      suggestionContent: /* @__PURE__ */ React.createElement(Button, { ...detailedViewButton, link: true, className: "header__search-suggestion-button", iconRight: "#arrow-right" }),
      formAttributes: {
        ...rest.formAttributes,
        role: "search"
      }
    }
  );
};
export {
  HeaderSearch
};
